import React, { useState, useEffect } from "react"
import PostCard from "./postCard"

const RelatedPosts = ({ related0, related1 }) => {
  const [relatedPosts, setRelatedposts] = useState([])

  const shuffle = ([...array]) => {
    for (let i = array.length - 1; i >= 0; i--) {
      const j = Math.floor(Math.random() * (i + 1))
      ;[array[i], array[j]] = [array[j], array[i]]
    }
    return array
  }
  const randomSelect = (array1, array0) => {
    let num = 6
    let newArray = []
    while (newArray.length < num && array1.length > 0) {
      for (let i in array1) {
        if (newArray.length >= num) {
          break
        }
        if (array1[i].frontmatter.shopPriority * 0.15 > Math.random()) {
          newArray.push(array1[i])
          array1.splice(i, 1)
        }
      }
    }
    while (newArray.length < num && array0.length > 0) {
      for (let j in array0) {
        if (newArray.length >= num) {
          break
        }
        if (array0[j].frontmatter.shopPriority * 0.15 > Math.random()) {
          newArray.push(array0[j])
          array0.splice(j, 1)
        }
      }
    }
    return newArray
  }

  useEffect(() => {
    setRelatedposts(
      randomSelect(shuffle(related1.nodes), shuffle(related0.nodes))
    )
  }, [related0, related1])

  return (
    <ul className="p-postList -type-card -related">
      {relatedPosts.map((node) => (
        <PostCard node={node} key={node.id} />
      ))}
    </ul>
  )
}

export default RelatedPosts
